import {
  SearchInventoryItemsResponse,
  CursorSearch,
} from './src/stores-catalog-v3-inventory-item-inventory-items-v-3.universal';

export * from './src/stores-catalog-v3-inventory-item-inventory-items-v-3.universal.js';

/** @hidden */
export type InventoryItemSearch = {};

/**
 * Retrieves a list of inventory items, given the provided filtering, sorting, and cursor paging.
 *
 *
 * Search Inventory Items runs with these defaults, which you can override:
 *
 * - `createdDate` is sorted in `DESC` order
 * - `cursorPaging.limit` is `100`
 *
 * To learn about working with _Search_ endpoints, see
 * [API Query Language](https://dev.wix.com/docs/api-reference/articles/work-with-wix-apis/data-retrieval/about-the-wix-api-query-language),
 * and [Sorting and Paging](https://dev.wix.com/docs/api-reference/articles/work-with-wix-apis/data-retrieval/about-sorting-and-paging).
 *
 * Learn more about the differences between [_Query_ and _Search_](https://dev.wix.com/docs/api-reference/articles/work-with-wix-apis/data-retrieval/about-search-query-and-list-methods) methods.
 * @param search - Search options.
 * @public
 * @requiredField search
 * @permissionId WIX_STORES.INVENTORY_READ
 * @applicableIdentity APP
 * @fqn com.wix.stores.catalog.inventory.api.v3.InventoryService.SearchInventoryItems
 */
export declare function searchInventoryItems(
  search: CursorSearch
): Promise<SearchInventoryItemsResponse>;
